module.exports = __webpack_public_path__ + "img/banner-climate-love.4c2269bc.jpg";